
<template>
    <div class="bd-about__section pt-30 pb-20 theme-bg">
        <div class="container">
            <div class="row align-items-center">
                <h1 class="text-center"> {{myTranslate.welcome}}</h1>
                <div class="col-lg-6">
                    <div class="bd-about__img w-img mr-20 mb-20 wow fadeInRight">
                        <v-img
                            width="558px"
                            height="558px"
                            :src="attrFil(data.image)"
                            :alt="attrFil(data.title)"
                            cover>

                        </v-img>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="bd-about__text mb-30 wow fadeInLeft">
                        <div class="bd-section__title-wrapper">
                            <h2 class="bd-section__title bd-section__title-lg">{{ myTranslate.slogan }}</h2>

                            <div class="black-text" id="content" v-html="truncateString(attrFil(data.content),1000)"></div>
                            <div class="bd-section__btn-wrapper">
                                <a aria-label="read more about us" :href="localeUrl+'about-us'" class="bd-btn">{{ myTranslate.readMore }}: {{ attrFil(data.title) }} <span><i
                                    class="fa-regular fa-angle-right"></i></span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>


export default {
    inject: ['localeUrl','myTranslate','lang'],
    props: ['data'],

    name: "About",
    data: () => ({

    }),
    methods: {
        attrFil(attr) {
            return attr[this.lang] || attr['en'] || attr
        },
        truncateString(str, maxLength) {
            if (str.length > maxLength) {
                return str.substring(0, maxLength) + '...';
            } else {
                return str;
            }
        }
    }
}
</script>

<style scoped>

</style>
